import {Circle as CircleStyle, Fill, Stroke, Style, Icon, RegularShape} from 'ol/style';

export function getCurrentStyle() {
	const style = new Style({
		fill: new Fill({
			color: '#FF6D61',
		}),
		stroke: new Stroke({
			color: '#FF6D61',
			width: .3,
		}),
	});

	return style
}

export function getRadiusStyle() {
	const style = new Style({
		stroke: new Stroke({
			color: '#07034A',
			width: 1
		}),
		fill: new Fill({
			color: 'rgba(0, 0, 255, 0.1)'
		})
	})

	return style
}


export function getZipStyle() {
	const style = new Style({
		stroke: new Stroke({
			color: '#07034A',
			width: 3
		}),
		fill: new Fill({
			color: '#07034A'
		})
	})

	return style;	
}

export function getMarkerStyle(feature, image) {
	let src = feature.get('Greenfield') == 'nee' ? `${image}.svg` : `${image}_green_circle.svg` ;
		var style = new Style({
			image: new Icon({
				opacity: .8,
				anchor: [0.5, 0.96],
				src: require(`@/assets/${src}`),
				scale: .6	
			})
		});

		var stroke = new Stroke({color: '#07034A', width: 2, lineDash: [1,2],
    lineDashOffset: 1});
		var fill = new Fill({color: 'rgba(6,10,70,0.4)', opacity: .6});


		let square = new Style({
			image: new RegularShape({
				fill: fill,
				stroke: stroke,
				points: 4,
				radius: 7,
				angle: Math.PI / 4
			})
		})

		// return feature.get('Opleverdatum') ? style : square;
		return style;
}